import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Shared/BreadCrumb/BreadCrumb";
import styles from "./Reviews.module.css";
import FAQItem from "../../Components/CustomerServices/FAQItem";
import ShopActions from "../../Components/Shared/ShopActions/ShopActions";
import SharedCS from "./SharedCS";
import * as Bootstrap from "react-icons/bs";

import useReviewStore from "../../Stores/useReviewStore";
import commonStyles from "../../Components/Shared/commonStyles.module.css";
import reviewStyles from "../../Components/Home/Reviews/Reviews.module.css";
import ReviewForm from "../../Components/CustomerServices/Reviews/ReviewForm";
import InfiniteScrollList from "../../Components/Shared/InfiniteScroll/InfiniteScrollList";
import ReviewItem from "../../Components/CustomerServices/Reviews/ReviewItem";
import CallToAction from "../../Components/Shared/CallToAction/CallToAction";

function Reviews() {
  const {
    reviews,
    reviewHighLights,
    getReviews,
    getReviewHighlights,
    loading,
    getReviewsPaged,
    resetErrors,
  } = useReviewStore();

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const GetReviews = async () => {
      await getReviewsPaged(1, 10);
    };

    if (reviews.length === 0) {
      GetReviews();
    }
  }, []);

  const handleWriteReviewClick = () => {
    setShowForm(true);

    // optional: align form to top when revealed
    requestAnimationFrame(() => {
      const el = document.getElementById("leave-a-review");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  };

  const handleHideReviewForm = () => {
    setShowForm(false);
    resetErrors();

    const el = document.getElementById("header");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className={styles.ReviewContainer}>
      <div className={`${commonStyles.section} `}>
        <Breadcrumb
          Route="Customer-Services"
          RouteLabel="Customer Services"
          ProductName="Customer Reviews"
        />
        <div id="header" className={styles.header}>
          <h1 className={styles.ReviewTitle}>See What Our Customers Say</h1>
          <p className={styles.ReviewDescription}>
            Discover why customers in Jersey love our personalised gifts and
            hampers. Real stories, real smiles.
          </p>
        </div>
        <button
          className={`${commonStyles.btn} ${commonStyles.btnSecondary} ${styles.WriteReviewButton}`}
          onClick={handleWriteReviewClick}
        >
          Write a Review
        </button>
        {showForm && (
          <div
            id="leave-a-review"
            className={`${commonStyles.section} ${styles.LeaveaReview}`}
          >
            <ReviewForm />
            <button
              className={`${commonStyles.btn} ${commonStyles.btnSecondary}`}
              onClick={handleHideReviewForm}
            >
              Cancel
            </button>
          </div>
        )}
      </div>

      <div>
        <div className={commonStyles.cards4}>
          <InfiniteScrollList
            fetchItems={getReviewsPaged}
            pageSize={5}
            RenderItem={ReviewItem}
            itemProps={{}}
          />
        </div>
        {/* {reviews && reviews.length === 0 && ( */}
          <div className={styles.WriteReviewSecond}>
            <button
              className={`${commonStyles.btn} ${commonStyles.btnSecondary} ${styles.WriteReviewButton}`}
              onClick={handleWriteReviewClick}
            >
              Write a Review
            </button>
          </div>
        {/* )} */}
        <CallToAction />
      </div>
    </div>
  );
}

export default Reviews;
